// If "empty" is selected, this is the layer name that is used.
export const EMPTY_LAYER_NAME = '';

// This is a constant shared with the floorplan-processor - every unit in the cad file is this
// number of pixels. This is important to be able to translate between cad image coordinate space
// anc CADCoordinates.
export const DEFAULT_PIXELS_PER_CAD_UNIT = 2;
